/**
 * @param {any} defValue default ref value
 * @returns [getter, setter]
 */
const useRef = (defValue) => {
  let value = defValue

  const get = () => value
  const set = (val) => {
    value = val
  }

  return [get, set]
}

export { useRef }
